// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Field-module__ui-Field--AXqj6 {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.Field-module__ui-Field-Label--_yBO5,
.Field-module__ui-Field-Description--ZwPHd {
  display: flex;
  width: 100%;
  align-items: center;
}

.Field-module__ui-Field-Label--_yBO5 {
  gap: 4px;
  margin-bottom: 8px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 1rem;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.8125px;
  word-break: break-word;
}

.Field-module__ui-Field-Content--EkioZ {
  display: flex;
  width: 100%;
  justify-content: stretch;
  gap: 8px;
}

.Field-module__ui-Field-Content--EkioZ > * {
  width: 100%;
  flex: 1;
}

.Field-module__ui-Field-Content--EkioZ > :where(button, a) {
  flex: 0 0 auto;
  width: fit-content;
}

.Field-module__ui-Field-Description--ZwPHd {
  gap: 4px;
  margin-top: 6px;
  color: var(--chaek-color-text-primary);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 19.5px;
  letter-spacing: -0.4262px;
  word-break: break-word;
}

.Field-module__leading--sHsXH,
.Field-module__trailing--OnMo4 {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.Field-module__leading--sHsXH > :where(img, svg),
.Field-module__trailing--OnMo4 > :where(img, svg) {
  display: block;
  width: 100%;
  height: 100%;
}

.Field-module__ui-Field-Label--_yBO5 .Field-module__leading--sHsXH,
.Field-module__ui-Field-Label--_yBO5 .Field-module__trailing--OnMo4 {
  width: 12px;
  height: 12px;
}

.Field-module__ui-Field-Description--ZwPHd .Field-module__leading--sHsXH,
.Field-module__ui-Field-Description--ZwPHd .Field-module__trailing--OnMo4 {
  width: 10px;
  height: 10px;
}

.Field-module__trailing--OnMo4 {
  margin-left: auto;
}

.Field-module__ui-Field--AXqj6 + .Field-module__ui-Field--AXqj6 {
  margin-top: 22px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Field/Field.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,iDAAiD;EACjD,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".ui-Field {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n\n.ui-Field-Label,\n.ui-Field-Description {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.ui-Field-Label {\n  gap: 4px;\n  margin-bottom: 8px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 22.4px;\n  letter-spacing: -0.8125px;\n  word-break: break-word;\n}\n\n.ui-Field-Content {\n  display: flex;\n  width: 100%;\n  justify-content: stretch;\n  gap: 8px;\n}\n\n.ui-Field-Content > * {\n  width: 100%;\n  flex: 1;\n}\n\n.ui-Field-Content > :where(button, a) {\n  flex: 0 0 auto;\n  width: fit-content;\n}\n\n.ui-Field-Description {\n  gap: 4px;\n  margin-top: 6px;\n  color: var(--chaek-color-text-primary);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 19.5px;\n  letter-spacing: -0.4262px;\n  word-break: break-word;\n}\n\n.leading,\n.trailing {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n}\n\n.leading > :where(img, svg),\n.trailing > :where(img, svg) {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.ui-Field-Label .leading,\n.ui-Field-Label .trailing {\n  width: 12px;\n  height: 12px;\n}\n\n.ui-Field-Description .leading,\n.ui-Field-Description .trailing {\n  width: 10px;\n  height: 10px;\n}\n\n.trailing {\n  margin-left: auto;\n}\n\n.ui-Field + .ui-Field {\n  margin-top: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Field": `Field-module__ui-Field--AXqj6`,
	"ui-Field-Label": `Field-module__ui-Field-Label--_yBO5`,
	"ui-Field-Description": `Field-module__ui-Field-Description--ZwPHd`,
	"ui-Field-Content": `Field-module__ui-Field-Content--EkioZ`,
	"leading": `Field-module__leading--sHsXH`,
	"trailing": `Field-module__trailing--OnMo4`
};
export default ___CSS_LOADER_EXPORT___;
